import { CommandContribution } from '@patsnap/tahiti-core';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ShareLinkDialogService } from '@/services/share-link/share-link-dialog-service';
import { createShareLinkDialogService } from '@/services/share-link/impls/share-link-dialog-service';
import { ShareLinkCommandContribution } from '@/services/share-link/impls/share-link-command-contribution';

/**
 * 分享链接模块
 * @description 注册分享链接相关的服务和命令
 */
export const shareLinkModule = new ContainerModule((bind) => {
    // 绑定分享链接对话框服务
    bind(ShareLinkDialogService).toDynamicValue(createShareLinkDialogService());

    // 绑定命令贡献
    bind(CommandContribution).to(ShareLinkCommandContribution);
});
